import {alphabetNavigationStyles} from "@insite/content-library/Widgets/Brand/AlphabetNavigation"
import { css } from "styled-components"

alphabetNavigationStyles.container = {
    css: css`
        text-transform: uppercase;
        justify-items: center;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        font-weight: 600;
    `,
}